import commonApi from '@/api/api.common'
export default [
  {
    type: 'input',
    placeholder: '版本号',
    filed: 'version',
    default: ''
  },
  {
    type: 'select',
    placeholder: '状态',
    filed: 'status',
    default: '',
    query: commonApi.forbidden_select
  }
]
